var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLpFooterTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2788_4168)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    stroke: "#0D1615"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85832 13.355C7.85832 13.355 14.0502 11.1598 16.1976 10.3869C17.0208 10.0777 19.8125 9.08827 19.8125 9.08827C19.8125 9.08827 21.101 8.65544 20.9936 9.70665C20.9578 10.1395 20.6715 11.6545 20.3852 13.2932C19.9557 15.6121 19.4904 18.1474 19.4904 18.1474C19.4904 18.1474 19.4188 18.8585 18.8104 18.9822C18.202 19.1059 17.1998 18.5494 17.0208 18.4256C16.8776 18.3329 14.3365 16.9416 13.4059 16.2614C13.1554 16.0759 12.8691 15.7049 13.4417 15.272C14.7302 14.2517 16.2692 12.984 17.1998 12.1802C17.6293 11.8091 18.0587 10.9434 16.2692 11.9946C13.7281 13.5096 11.2227 14.9319 11.2227 14.9319C11.2227 14.9319 10.65 15.241 9.57629 14.9628C8.50252 14.6845 7.24983 14.3135 7.24983 14.3135C7.24983 14.3135 6.39089 13.8497 7.85832 13.355Z",
    fill: "#0D1615"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2788_4168",
    x: 0,
    y: 0,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2788_4168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2788_4168",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpFooterTelegram);
export default __webpack_public_path__ + "static/media/lp-footer-telegram.33a0819963a3016791692869bf03d2a1.svg";
export { ForwardRef as ReactComponent };